import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './styles/global.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found in index.html');
}

// Serve under a subpath when built with a Vite base (e.g. '/real-estate/' for
// path-based routing behind CloudFront). BASE_URL is '/' for a root build.
const basename = import.meta.env.BASE_URL.replace(/\/+$/, '') || '/';

createRoot(container).render(
  <StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
